import React, { memo, useContext, useEffect, useState } from 'react';
import * as L from 'leaflet';

import {
	MapContainer,
	TileLayer,
	LayerGroup,
	GeoJSON,
	Marker,
	Popup,
	useMap,
	useMapEvents,
	LayersControl,
} from 'react-leaflet';
import { icon, LatLngTuple, latLng } from 'leaflet';
import { LayerContext } from '../context/LayerContext';
// import AddMarkersButton from './AddMarkersButton';
import dataPoints1 from '../../data/dataPoints1.json';
import dataPoints2 from '../../data/dataPoints2.json';
import dataPoints3 from '../../data/dataPoints3.json';
// import AddMarkerButton from './AddMarkerButton';

import './leaflet-map.css';
import LocationMarker from './LocationMarker';
import LoadMarkers from './LoadMarkers';
import MegurimIcon from '../../img/megurimIcon.svg';
import MegurimIconSelected from '../../img/megurimIconSelected.svg';
import TaasukaIcon from '../../img/taasukaIcon.svg';
import TaasukaIconSelected from '../../img/taasukaIconSelected.svg';
import auctionLocationsUtils from '../../utils/auctionLocationsUtils';
import RedIcon from '../../img/red.svg';
import GreenIcon from '../../img/green.svg';

const outerBounds: LatLngTuple = [31.969493923993348, 34.8473946520902];
const zoom: number = 8;
type PointData = {
	title: string;
	description: string;
	latlng: { lat: number; lng: number };
	type: string;
} | null;
// var redIcon = L.icon({
// 	iconUrl: RedIcon,
// 	// iconSize: [38, 95],
// 	// iconAnchor: [22, 94],
// 	// popupAnchor: [-3, -76],
// 	// // shadowUrl: 'my-icon-shadow.png',
// 	// shadowSize: [68, 95],
// 	// shadowAnchor: [22, 94],
// });
// var greenIcon = L.icon({
// 	iconUrl: GreenIcon,
// 	// iconSize: [38, 95],
// 	// iconAnchor: [22, 94],
// 	// popupAnchor: [-3, -76],
// 	// // shadowUrl: 'my-icon-shadow.png',
// 	// shadowSize: [68, 95],
// 	// shadowAnchor: [22, 94],
// });
// const LeafletMap: React.FC = () => {
export default function LeafletMap() {
	const [selectedIndex, setSelectedIndex] = useState(-1);
	const {
		setAllPoints,
		setDrawedPoints,
		drawedPoints,
		selectedPointIdGlobal,
		setSelectedPointIdGlobal,
		activePark,
		setActivePark,
		setMap,
		point,
		points,
	} = useContext(LayerContext);
	// const { point, points, setMap } = useContext(LayerContext);
	const [data, setData] = useState<any>([]);
	// const [displayIcon, setDisplayIcon] = useState<Number>(0);

	// const [activePark, setActivePark] = React.useState<PointData>(null);
	// function createIcon(url: any) {
	// 	return new L.Icon({
	// 		iconUrl: url,
	// 	});
	// }
	// useEffect(() => {
	// 	const getAllPoints = async () => {
	// 		const resp2 = await auctionLocationsUtils.getAllAuctionLocations(); // 500ms
	// 		console.log(resp2.data);
	// 		setData(resp2.data);
	// 	};
	// 	getAllPoints();
	// }, []);
	// function handleClick(e: any) {
	// 	setSelectedIndex(e.target.options.index);
	// }
	// function getMarkerIcon(index: any, pointInfo: PointData) {
	// 	console.log(pointInfo);
	// 	switch (pointInfo?.type!) {
	// 		case 'תעסוקה':
	// 			if (index === selectedIndex) return createIcon(TaasukaIconSelected);
	// 			return createIcon(TaasukaIcon);
	// 			break;

	// 		default:
	// 			if (index === selectedIndex) return createIcon(MegurimIconSelected);
	// 			return createIcon(MegurimIcon);
	// 			break;
	// 	}
	// }
	// myMap.on('moveend', function (event) {
	// 	var bounds = event.target.getBounds();
	// 	console.log(bounds);
	// });
	// myMap.on('moveend', function (event) {
	// 	var bounds = event.target.getBounds();
	// 	console.log(bounds);
	// });
	// function getMarkerIcon(index: any, pointInfo: any) {
	// 	// console.log(pointInfo);
	// 	switch (pointInfo?.type!) {
	// 		case 'תעסוקה':
	// 			if (pointInfo?._id === selectedPointId) return redIcon;
	// 			return redIcon;
	// 			break;

	// 		default:
	// 			if (pointInfo?._id === selectedPointId) return greenIcon;
	// 			return greenIcon;
	// 			break;
	// 	}
	// }
	console.log('LeafletMap renders');
	// const onEachFeaturePoint = (feature: any, layer: any) => {
	// 	// console.log('feature: ', feature);
	// 	// console.log('layer: ', layer);
	// 	layer.on({
	// 		click: function (e: any) {
	// 			console.log('e: ', e);
	// 			console.log('click');
	// 			//setDisplayIcon(feature.id);
	// 			//layer.setIcon((layer.options.icon = greenIcon));
	// 		},
	// 		mouseover: function (e: any) {
	// 			console.log('e: ', e);
	// 			console.log('hover');
	// 			setDisplayIcon(feature.id);
	// 			//layer.setIcon((layer.options.icon = greenIcon));
	// 		},
	// 	});
	// };

	// const pointToLayer = (feature: any, latlng: any) => {
	// 	//return L.circleMarker(latlng, undefined); // Change marker to circle
	// 	return L.marker(latlng, {
	// 		icon: displayIcon == feature.id ? greenIcon : redIcon,
	// 	}); // Change the icon to a custom icon
	// };
	return (
		<MapContainer
			id="mapId"
			center={outerBounds}
			zoom={zoom}
			whenCreated={setMap}
			zoomControl={false}
		>
			{' '}
			<LayersControl position="topright">
				<LayersControl.BaseLayer checked name="מפה">
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
				</LayersControl.BaseLayer>
				<LayersControl.BaseLayer name="לווין">
					<TileLayer
						attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
						url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
						maxZoom={17}
					/>
				</LayersControl.BaseLayer>
				{/* <LayersControl.BaseLayer name="מפה3">
					<TileLayer
						attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community"
						url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'"
						maxZoom={17}
					/>
				</LayersControl.BaseLayer>
				<LayersControl.BaseLayer name="מפה4">
					<TileLayer
						attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
						url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
						maxZoom={17}
					/>
				</LayersControl.BaseLayer> */}
			</LayersControl>
			<LayerGroup>{point}</LayerGroup>
			<LayerGroup>{points}</LayerGroup>
			<TileLayer
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			/>
			<LoadMarkers />
			{/* <GeoJSON attribution="&copy; credits due..." data={data} /> */}
			{/* <GeoJSON
				data={data}
				key={`geojson-${Math.random()}`}
				style={() => ({
					color: '#4a83ec',
					weight: 0.5,
					fillColor: '#1a1d62',
					fillOpacity: 1,
				})}
				pointToLayer={(feature, latlng) => pointToLayer(feature, latlng)}
				onEachFeature={(feature, layer) => onEachFeaturePoint(feature, layer)}
			/> */}
		</MapContainer>
	);
}

// export default memo(LeafletMap);
